//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
  name: 'News',

  data() {
    return {
      CDN: process.env.CDN,
    };
  },

  computed: {
    ...mapState(['newsDetail']),
  },

  async validate({ store, params }) {
    const newsDetail = await store.dispatch('getNewsDetail', params.newsId);
    return !!newsDetail;
  },
};
